import VueTheMask from 'vue-the-mask';
import money from 'v-money'
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueTheMask)
    nuxtApp.vueApp.use(money, {precision: 4})

})